// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @16/01/2024 14:49:33
import { ListUnitTypes_abstract } from './../../abstract/SagaSchema/ListObjects/ListUnitTypes_abstract';
export class ListUnitTypes extends ListUnitTypes_abstract {}
